import { waitForNudgeSchedulerInitialized } from './orchestratorUtils';
import { captureError } from './errorUtils';
export const ORCHESTRATOR_EVENT = 'Orchestrator:triggerNudge';
/**
 * Trigger a nudge refresh, if the externalIdentifier is provided, it will be used to fetch that specific nudge.
 *
 * Use cases:
 * - start a tour using its external identifier, without needing a page refresh or route change
 * - trigger an early scheduler check for nudge eligibility. This could be done after triggering an event meeting the conditions.
 *
 * @param externalIdentifier
 * @returns void
 */
export const triggerNudge = (externalIdentifier = '', mode = 'schedule') => {
  waitForNudgeSchedulerInitialized().then(() => {
    window.dispatchEvent(new CustomEvent(ORCHESTRATOR_EVENT, {
      detail: {
        value: externalIdentifier,
        mode
      }
    }));
  }).catch(error => {
    captureError('Failed to trigger nudge', error);
  });
};